var map = {
	"./en/common.json": 53213,
	"./en/footer.json": 61049,
	"./en/landing.json": 97260,
	"./en/legal/cgv.json": 41915,
	"./en/legal/privacy.json": 7100,
	"./en/legal/terms.json": 16315,
	"./fr/common.json": 64184,
	"./fr/footer.json": 69744,
	"./fr/landing.json": 79822,
	"./fr/legal/cgv.json": 33537,
	"./fr/legal/privacy.json": 80275,
	"./fr/legal/terms.json": 45362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82765;